
import '../App.css';
import React, { useState, useEffect, useRef, useMemo } from 'react';
import { ref, query, limitToLast, onValue, off, orderByChild } from "firebase/database";
import { useNavigate } from 'react-router-dom';
import { db } from '../config';
import "@fontsource/open-sans"; // Defaults to weight 400
import "@fontsource/open-sans/400.css"; // Specify weight
import "@fontsource/open-sans/400-italic.css"; // Specify weight and style
import "@fontsource/poppins"; // Defaults to weight 400
import "@fontsource/poppins/400.css"; // Specify weight
import "@fontsource/poppins/400-italic.css"; // Specify weight and style
import { FaArrowLeftLong } from "react-icons/fa6";
import { FaArrowRightLong } from "react-icons/fa6";


import { useLocation } from "react-router-dom";
import LOGO from "../logo2.png";


export default function All_episodes() {


    const location = useLocation();
    const episodes = location.state?.episodes || []; // ✅ received array


    const [screenWidth, setScreenWidth] = useState(window.innerWidth);
    const [screenHeight, setScreenHeight] = useState(window.innerHeight);
    const navigate = useNavigate();

    useEffect(() => {
        const onResize = () => {
            setScreenWidth(window.innerWidth);
            setScreenHeight(window.innerHeight);
        };
        window.addEventListener("resize", onResize);
        return () => window.removeEventListener("resize", onResize);
    }, []);




    const isMobile = screenWidth <= 924;


    const pagePad = isMobile ? 14 : Math.max(18, Math.min(44, screenWidth * 0.022));



    // ✅ Bottom player state


    const audioRef = useRef(null);
    const [currentIndex, setCurrentIndex] = useState(0);
    const [isPlaying, setIsPlaying] = useState(false);
    const [cur, setCur] = useState(0);
    const [dur, setDur] = useState(0);
    const [vol, setVol] = useState(0.85);



    const footerTitle = { fontSize: 18, fontWeight: 700, marginBottom: 12 };

    // ✅ active episode
    const activeEp = episodes?.[currentIndex] || null;




    // helpers (put above return)
    const fmtDate = (msOrIso) => {
        const ms = Number(msOrIso);
        const d = isFinite(ms) ? new Date(ms) : new Date(msOrIso);
        if (Number.isNaN(d.getTime())) return "";
        return d.toLocaleDateString(undefined, { weekday: "short", year: "numeric", month: "short", day: "numeric" });
    };

    const fmtMs = (msStr) => {
        const ms = Number(msStr);
        if (!isFinite(ms) || ms <= 0) return "0:00";
        const sec = Math.floor(ms / 1000);
        const h = Math.floor(sec / 3600);
        const m = Math.floor((sec % 3600) / 60);
        const s = sec % 60;
        if (h > 0) return `${h}:${String(m).padStart(2, "0")}:${String(s).padStart(2, "0")}`;
        return `${m}:${String(s).padStart(2, "0")}`;
    };

    // Read More state (put near your other useState)
    const [expandedIds, setExpandedIds] = useState(() => new Set());

    const toggleExpanded = (id) => {
        setExpandedIds((prev) => {
            const next = new Set(prev);
            if (next.has(id)) next.delete(id);
            else next.add(id);
            return next;
        });
    };


    // ✅ helper: time format
    const fmt = (s) => {
        if (!s || !isFinite(s)) return "0:00";
        const sec = Math.floor(s);
        const h = Math.floor(sec / 3600);
        const m = Math.floor((sec % 3600) / 60);
        const r = sec % 60;
        if (h > 0) return `${h}:${String(m).padStart(2, "0")}:${String(r).padStart(2, "0")}`;
        return `${m}:${String(r).padStart(2, "0")}`;
    };

    // ✅ attach audio listeners ONCE


    const attachedRef = useRef(false);

    useEffect(() => {
        const a = audioRef.current;

        // if audio not mounted yet, do nothing (will run again next render)
        if (!a) return;

        // avoid double attaching
        if (attachedRef.current) return;
        attachedRef.current = true;

        const onLoaded = () => setDur(a.duration || 0);
        const onTime = () => setCur(a.currentTime || 0);
        const onPlay = () => setIsPlaying(true);
        const onPause = () => setIsPlaying(false);

        const onEnded = () => {
            setIsPlaying(false);
            setCurrentIndex((i) => {
                const next = i + 1;
                return next < episodes.length ? next : i;
            });
        };

        const onError = () => {
            console.log("AUDIO ERROR:", a.error);
            console.log("currentSrc:", a.currentSrc);
            setIsPlaying(false);
        };

        a.addEventListener("loadedmetadata", onLoaded);
        a.addEventListener("durationchange", onLoaded);
        a.addEventListener("timeupdate", onTime);
        a.addEventListener("play", onPlay);
        a.addEventListener("pause", onPause);
        a.addEventListener("ended", onEnded);
        a.addEventListener("error", onError);

        return () => {
            attachedRef.current = false;
            a.removeEventListener("loadedmetadata", onLoaded);
            a.removeEventListener("durationchange", onLoaded);
            a.removeEventListener("timeupdate", onTime);
            a.removeEventListener("play", onPlay);
            a.removeEventListener("pause", onPause);
            a.removeEventListener("ended", onEnded);
            a.removeEventListener("error", onError);
        };
        // IMPORTANT: include episodes.length so onEnded uses correct length
    }, [episodes.length]);


    // ✅ when episode changes, set src (NO fetch, so no CORS fetch problems)

    useEffect(() => {
        const a = audioRef.current;
        if (!a) return;

        if (!activeEp?.audioUrl) {
            a.pause();
            a.removeAttribute("src");
            a.load();
            setCur(0);
            setDur(0);
            setIsPlaying(false);
            return;
        }

        const wasPlaying = !a.paused;

        setCur(0);
        setDur(0);

        a.pause();
        a.currentTime = 0;

        a.src = activeEp.audioUrl;
        a.preload = "metadata";
        a.crossOrigin = "anonymous";
        a.volume = vol;
        a.load();

        if (wasPlaying || isPlaying) {
            const p = a.play();
            if (p?.catch) p.catch((e) => console.log("play() blocked:", e));
        }
    }, [activeEp?.audioUrl]); // ✅ important


    // ✅ keep volume synced
    useEffect(() => {
        const a = audioRef.current;
        if (!a) return;
        a.volume = vol;
    }, [vol]);

    // ✅ Play / Pause (must be called from a user click)
    const togglePlay = async () => {
        const a = audioRef.current;
        if (!a || !activeEp?.audioUrl) return;

        try {
            if (!a.src) {
                a.src = activeEp.audioUrl;
                a.preload = "metadata";
                a.crossOrigin = "anonymous";
                a.load();
            }

            if (a.paused) {
                await a.play(); // isPlaying updates by events
            } else {
                a.pause();
            }
        } catch (e) {
            console.log("togglePlay error:", e);
            setIsPlaying(false);
        }
    };

    // ✅ Play an episode from list
    const playEpisodeAtIndex = async (idx) => {
        if (idx < 0 || idx > episodes.length - 1) return;

        // same episode -> toggle
        if (idx === currentIndex) {
            togglePlay();
            return;
        }

        setCurrentIndex(idx);

        // next tick: play after src changed
        setTimeout(async () => {
            const a = audioRef.current;
            if (!a) return;
            try {
                await a.play();
            } catch (e) {
                console.log("playEpisodeAtIndex error:", e);
                setIsPlaying(false);
            }
        }, 0);
    };

    // ✅ Seek (slider 0..1000)
    const seekTo = (val) => {
        const a = audioRef.current;
        if (!a || !dur) return;

        const pct = Number(val) / 1000;
        const t = Math.max(0, Math.min(dur, pct * dur));
        a.currentTime = t;
        setCur(t);
    };

    const canPrev = currentIndex > 0;
    const canNext = currentIndex < episodes.length - 1;

    const goPrev = () => {
        if (!canPrev) return;
        playEpisodeAtIndex(currentIndex - 1);
    };

    const goNext = () => {
        if (!canNext) return;
        playEpisodeAtIndex(currentIndex + 1);
    };

    // ✅ spacer so footer/content doesn't hide behind fixed player
    const playerH = isMobile ? 208 : 245;





    // ✅ small helper to keep your "press" effect clean (works on mouse + touch)


    const pressDown = (e) => {
        e.currentTarget.style.transform = "scale(0.98)";
    };

    const pressUp = (e) => {
        e.currentTarget.style.transform = "scale(1)";
        e.currentTarget.style.background = "rgba(255,255,255,0.12)";
    };

    const hoverIn = (e) => {
        e.currentTarget.style.background = "rgba(255,255,255,0.16)";
    };

    const hoverOut = (e) => {
        e.currentTarget.style.background = "transparent";
    };




    ////////////////


    const pressDown3 = (e) => {
        e.stopPropagation();
        e.currentTarget.style.transform = "scale(0.98)";
    };
    const pressUp3 = (e) => {
        e.stopPropagation();
        e.currentTarget.style.transform = "scale(1)";
    };
    const hoverIn3 = (e) => {
        e.currentTarget.style.background = "rgba(255,255,255,0.12)";
    };
    const hoverOut3 = (e) => {
        e.currentTarget.style.background = "transparent";
    };

    ////////////


    function smoothScrollTo(container, targetY, duration = 1200) {
        const startY = container === window ? window.scrollY : container.scrollTop;
        const startTime = performance.now();

        function easeInOutCubic(t) {
            return t < 0.5
                ? 4 * t * t * t
                : 1 - Math.pow(-2 * t + 2, 3) / 2;
        }

        function animate(currentTime) {
            const elapsed = currentTime - startTime;
            const progress = Math.min(elapsed / duration, 1);
            const eased = easeInOutCubic(progress);

            const currentY = startY + (targetY - startY) * eased;

            if (container === window) {
                window.scrollTo(0, currentY);
            } else {
                container.scrollTop = currentY;
            }

            if (progress < 1) {
                requestAnimationFrame(animate);
            }
        }

        requestAnimationFrame(animate);
    }

    // --- List 3: newest-first ordering ---


    const getKey = (x) => x?.item_id || x?.guid || x?.link || x?.audioUrl || "";

    const getTs = (x) => {
        if (x?.publishedAtMs) return Number(x.publishedAtMs) || 0;
        const d = x?.isoDate || x?.pubDate;
        const t = d ? new Date(d).getTime() : 0;
        return Number.isFinite(t) ? t : 0;
    };

    // UI list newest-first
    const episodesNewestFirst = useMemo(() => {
        const arr = [...episodes];
        arr.sort((a, b) => getTs(b) - getTs(a));
        return arr;
    }, [episodes]);


    return (

        <>
            {/* hidden audio (audio only) */}

            <audio
                ref={audioRef}
                preload="metadata"
                playsInline
                style={{ display: "none" }}
            />


            <div
                style={{
                    backgroundColor: "white",
                    boxSizing: "border-box",
                    width: screenWidth,

                    paddingLeft: `calc(${pagePad}px + env(safe-area-inset-left))`,
                    paddingRight: `calc(${pagePad}px + env(safe-area-inset-right))`,

                    display: "flex",
                    justifyContent: "flex-start",
                    alignItems: "flex-start",
                    flexDirection: "column",
                    paddingBottom: playerH, // ✅ keeps content safe above player
                }}
            >
                {/* ================= ALL EPISODES BANNER ================= */}
                <div
                    style={{
                        width: screenWidth,
                        background: "#1F6F78",
                        height: isMobile ? 90 : 130,
                        display: "flex",
                        alignItems: "center",
                        padding: isMobile ? "0 14px" : "0 28px",
                        boxSizing: "border-box",
                        alignSelf: "center",
                    }}
                >
                    {/* LEFT : BACK BUTTON */}
                    <div style={{ flex: 1, display: "flex", alignItems: "center" }}>
                        <button
                            onClick={() => navigate("/")}
                            style={{
                                background: "transparent",
                                border: "none",
                                color: "#FFFFFF",
                                cursor: "pointer",
                                fontSize: isMobile ? 14 : 16,
                                fontWeight: 600,
                                display: "flex",
                                alignItems: "center",
                                gap: 8,
                                fontFamily: "Poppins",
                            }}

                            onMouseDown={pressDown3}
                            onMouseUp={pressUp3}
                            onMouseEnter={hoverIn3}
                            onMouseLeave={hoverOut3}
                            onTouchStart={pressDown3}
                            onTouchEnd={pressUp3}
                        >
                            <FaArrowLeftLong color="#FFFFFF" />
                            Back
                        </button>
                    </div>

                    {/* CENTER : TITLE */}
                    <div
                        style={{
                            flex: 2,
                            textAlign: "center",
                            fontSize: isMobile ? 26 : 44,
                            fontWeight: 800,
                            color: "#FFFFFF",
                            letterSpacing: 0.6,
                            fontFamily: "Poppins",
                            whiteSpace: "nowrap",
                        }}
                    >
                        All Episodes
                    </div>

                    {/* RIGHT : LOGO */}
                    <div style={{ flex: 1, display: "flex", justifyContent: "flex-end", alignItems: "center" }}>
                        <img
                            src={LOGO}
                            alt="Podcast Logo"
                            style={{
                                width: isMobile ? 45 : 80,
                                height: isMobile ? 45 : 80,
                                borderRadius: "50%",
                                objectFit: "cover",
                            }}
                        />
                    </div>
                </div>

                {/* ✅ MORE SECTION */}
                <div
                    style={{
                        width: isMobile ? "95%" : Math.round(screenWidth * 0.94),
                        marginLeft: "auto",
                        marginRight: "auto",
                        marginTop: isMobile ? 36 : 60,
                        fontFamily: "Poppins",
                    }}
                >
                    {/* LIST */}

                    <div style={{ display: "flex", flexDirection: "column", gap: isMobile ? 20 : 28 }}>
                        {episodesNewestFirst.map((item, uiIdx) => {
                            const id = getKey(item) || String(uiIdx);
                            const isExpanded = expandedIds.has(id);

                            const imgSrc = item?.imageUrl || item?.showImageUrl || "";
                            const title = item?.title || "Untitled Episode";
                            const epNo = item?.episodeNumber ?? item?.generatedEpisodeNumber ?? "";
                            const dateText = item?.publishedAtMs
                                ? fmtDate(item.publishedAtMs)
                                : (item?.pubDate || item?.isoDate || "");
                            const durText = item?.audioLength ? fmtMs(item.audioLength) : "";
                            const snippet = item?.contentSnippet || "";

                            // ✅ IMPORTANT: map UI item back to the real index in `episodes` (player source of truth)
                            const realIdx = episodes.findIndex((e) => getKey(e) === id);

                            const isActive = realIdx === currentIndex;

                            return (
                                <div
                                    key={id}
                                    style={{
                                        position: "relative",
                                        background: "#FFFFFF",
                                        borderRadius: isMobile ? 18 : 22,
                                        padding: isMobile ? 14 : 18,
                                        border: "2px solid rgba(15,23,42,0.10)",
                                        overflow: "hidden",
                                    }}
                                >
                                    <div
                                        style={{
                                            position: "relative",
                                            zIndex: 2,
                                            display: "flex",
                                            gap: isMobile ? 14 : 22,
                                            flexDirection: isMobile ? "column" : "row",
                                        }}
                                    >
                                        {/* IMAGE */}
                                        <div
                                            style={{
                                                flex: isMobile ? "unset" : "0 0 280px",
                                                height: isMobile ? 200 : 220,
                                                borderRadius: 14,
                                                overflow: "hidden",
                                                background: "#F1F5F9",
                                                border: "1px solid rgba(15,23,42,0.08)",
                                            }}
                                        >
                                            {imgSrc ? (
                                                <img
                                                    src={imgSrc}
                                                    alt={title}
                                                    style={{ width: "100%", height: "100%", objectFit: "cover" }}
                                                />
                                            ) : (
                                                <div
                                                    style={{
                                                        width: "100%",
                                                        height: "100%",
                                                        display: "grid",
                                                        placeItems: "center",
                                                        color: "rgba(15,23,42,0.45)",
                                                        fontWeight: 700,
                                                    }}
                                                >
                                                    No Image
                                                </div>
                                            )}
                                        </div>

                                        {/* CONTENT */}
                                        <div style={{ flex: 1, minWidth: 0 }}>
                                            <div
                                                style={{
                                                    fontSize: isMobile ? 15 : 17,
                                                    fontWeight: 600,
                                                    color: "rgba(15,23,42,0.70)",
                                                    marginBottom: 4,
                                                    textAlign: "left",
                                                }}
                                            >
                                                Ep. {epNo}
                                            </div>

                                            <div
                                                style={{
                                                    fontSize: isMobile ? 20 : 26,
                                                    lineHeight: isMobile ? "28px" : "34px",
                                                    fontWeight: 700,
                                                    color: "#1F6F78",
                                                    letterSpacing: -0.3,
                                                    textAlign: "left",
                                                }}
                                            >
                                                {title}
                                            </div>

                                            <div
                                                style={{
                                                    marginTop: 10,
                                                    display: "flex",
                                                    alignItems: "center",
                                                    gap: 10,
                                                    flexWrap: "wrap",
                                                    fontSize: isMobile ? 13 : 15,
                                                    color: "rgba(15,23,42,0.70)",
                                                    fontWeight: 600,
                                                    textAlign: "left",
                                                }}
                                            >
                                                <span>🕒 {durText || "—"}</span>
                                                <span style={{ opacity: 0.5 }}>|</span>
                                                <span>📅 {dateText || "—"}</span>
                                            </div>

                                            {/* SNIPPET (3 lines default) */}
                                            <div
                                                style={{
                                                    marginTop: 12,
                                                    fontSize: isMobile ? 14 : 17,
                                                    lineHeight: isMobile ? "22px" : "26px",
                                                    color: "rgba(15,23,42,0.78)",
                                                    fontWeight: 500,
                                                    maxWidth: 760,
                                                    textAlign: "left",

                                                    display: "-webkit-box",
                                                    WebkitBoxOrient: "vertical",
                                                    WebkitLineClamp: isExpanded ? "unset" : 3,
                                                    overflow: "hidden",
                                                }}
                                            >
                                                {snippet}
                                            </div>

                                            {/* Read More / Read Less */}
                                            {snippet?.length ? (
                                                <div
                                                    onClick={() => toggleExpanded(id)}
                                                    style={{
                                                        marginTop: 10,
                                                        fontSize: isMobile ? 14 : 16,
                                                        fontWeight: 700,
                                                        color: "#1F6F78",
                                                        cursor: "pointer",
                                                        textAlign: "left",
                                                        userSelect: "none",
                                                        WebkitTapHighlightColor: "transparent",
                                                        WebkitUserSelect: "none",
                                                    }}
                                                >
                                                    {isExpanded ? "Read Less" : "Read More"}
                                                </div>
                                            ) : null}
                                        </div>

                                        {/* PLAY */}
                                        <div
                                            style={{
                                                display: "flex",
                                                alignItems: isMobile ? "flex-start" : "center",
                                                justifyContent: "center",
                                            }}
                                        >
                                            <button
                                                onClick={() => {
                                                    if (realIdx >= 0) playEpisodeAtIndex(realIdx);
                                                }}
                                                disabled={realIdx < 0}
                                                style={{
                                                    width: isMobile ? 56 : 66,
                                                    height: isMobile ? 56 : 66,
                                                    borderRadius: 999,
                                                    border: "none",
                                                    background: isActive && isPlaying ? "#0B5560" : "#1F6F78",
                                                    cursor: realIdx >= 0 ? "pointer" : "not-allowed",
                                                    opacity: realIdx >= 0 ? 1 : 0.45,
                                                    display: "grid",
                                                    placeItems: "center",
                                                    color: "white",
                                                    fontSize: 18,
                                                    fontWeight: 700,
                                                }}
                                                title="Play"
                                            >
                                                {isActive && isPlaying ? "❚❚" : "▶"}
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            );
                        })}
                    </div>


                </div>

                {/* ================= FOOTER ================= */}
                <div
                    style={{
                        width: screenWidth,
                        background: "#1F6F78",
                        padding: isMobile ? "36px 18px 22px" : "56px 70px 26px",
                        boxSizing: "border-box",
                        color: "#FFFFFF",
                        fontFamily: "Poppins",
                        alignSelf: "center",
                        marginTop: isMobile ? 50 : 70,
                    }}
                >
                    <div
                        style={{
                            display: "flex",
                            flexDirection: isMobile ? "column" : "row",
                            alignItems: isMobile ? "center" : "flex-start",
                            justifyContent: "space-between",
                            gap: isMobile ? 32 : 0,
                        }}
                    >
                        <div style={{ textAlign: isMobile ? "center" : "left" }}>
                            <div
                                style={{
                                    width: isMobile ? 140 : 160,
                                    height: isMobile ? 140 : 160,
                                    borderRadius: "50%",
                                    overflow: "hidden",
                                    background: "#fff",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                }}
                            >
                                <img
                                    src={LOGO}
                                    alt="The Nurse and The Midwife"
                                    style={{ width: "100%", height: "100%", objectFit: "cover" }}
                                />
                            </div>
                        </div>

                        <div style={{ minWidth: 160 }}>

                            <div style={footerTitle}>Quick Links</div>



                            <div
                                style={{
                                    marginTop: 10,
                                    display: "flex",
                                    flexDirection: "column",
                                    gap: 10,
                                    alignItems: "flex-start",
                                }}
                            >


                                {/* EPISODES */}
                                <div
                                    role="button"
                                    tabIndex={0}
                                    onClick={(e) => {
                                        smoothScrollTo(window, 0, 1200);
                                    }}

                                    style={{
                                        height: 30,
                                        paddingLeft: 10,
                                        paddingRight: 10,
                                        borderRadius: 999,
                                        display: "inline-flex",
                                        alignItems: "center",
                                        gap: 5,
                                        color: "rgba(255,255,255,0.92)",
                                        fontSize: isMobile ? 14 : 15,
                                        fontWeight: 600,
                                        userSelect: "none",
                                        cursor: "pointer",
                                        transition: "transform 0.15s ease, background 0.15s ease",
                                        whiteSpace: "nowrap",
                                        width: "fit-content",
                                        alignSelf: "center",
                                    }}
                                    onMouseDown={pressDown3}
                                    onMouseUp={pressUp3}
                                    onMouseEnter={hoverIn3}
                                    onMouseLeave={hoverOut3}
                                    onTouchStart={pressDown3}
                                    onTouchEnd={pressUp3}
                                >
                                    Episodes
                                </div>
                            </div>



                        </div>


                        <div style={{ minWidth: 220 }}>
                            <div style={footerTitle}>Listen On</div>

                            <div
                                style={{
                                    marginTop: 10,
                                    display: "flex",
                                    flexDirection: "column", // ✅ column-wise
                                    gap: 10,
                                    alignItems: "flex-start",

                                }}
                            >
                                {[
                                    {
                                        label: "Spotify",
                                        href: "https://open.spotify.com/", // ✅ put your real link

                                    },
                                    {
                                        label: "Apple Podcasts",
                                        href: "https://podcasts.apple.com/", // ✅ put your real link

                                    },
                                    {
                                        label: "Acast",
                                        href: "https://shows.acast.com/thenurseandthemidwife", // ✅ put your real link

                                    },
                                ].map((p) => (
                                    <a
                                        key={p.label}
                                        href={p.href}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        style={{ textDecoration: "none", alignSelf: 'center' }}
                                    >
                                        <div
                                            style={{
                                                height: isMobile ? 30 : 30,
                                                paddingLeft: 10,
                                                paddingRight: 10,
                                                borderRadius: 999,
                                                //  background: "rgba(255,255,255,0.12)",
                                                //  border: "1px solid rgba(255,255,255,0.16)",
                                                // backdropFilter: "blur(10px)",
                                                display: "inline-flex",
                                                alignItems: "center",
                                                gap: 5,
                                                // boxShadow: "0 10px 26px rgba(0,0,0,0.22)",
                                                color: "rgba(255,255,255,0.92)",
                                                fontSize: isMobile ? 14 : 15,
                                                fontWeight: 600,
                                                userSelect: "none",
                                                cursor: "pointer",
                                                transition: "transform 0.15s ease, background 0.15s ease",
                                                whiteSpace: "nowrap",
                                                width: "fit-content",
                                                alignSelf: 'center'
                                            }}
                                            onMouseDown={pressDown}
                                            onMouseUp={pressUp}
                                            onMouseEnter={hoverIn}
                                            onMouseLeave={hoverOut}
                                            onTouchStart={pressDown}
                                            onTouchEnd={pressUp}
                                        >
                                            {p.icon}
                                            <div>{p.label}</div>
                                        </div>
                                    </a>
                                ))}
                            </div>
                        </div>


                        {/* SOCIALS */}
                        <div
                            style={{
                                minWidth: 120,
                                display: "flex",
                                flexDirection: "column",
                                justifyContent: "center",
                                alignContent: "center",
                            }}
                        >
                            <div style={footerTitle}>Socials</div>

                            <a
                                href="https://www.instagram.com/thenurseandthemidwife?igsh=MzVsZ3BvMHJtMXVw&utm_source=qr"
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{
                                    marginTop: 10,
                                    width: 36,
                                    height: 36,
                                    borderRadius: 8,
                                    border: "1.5px solid rgba(255,255,255,0.7)",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    cursor: "pointer",
                                    alignSelf: "center",
                                    textDecoration: "none",
                                    transition: "transform 0.15s ease, background 0.15s ease",
                                }}
                                onMouseDown={pressDown}
                                onMouseUp={pressUp}
                                onMouseEnter={hoverIn}
                                onMouseLeave={hoverOut}
                                onTouchStart={pressDown}
                                onTouchEnd={pressUp}
                            >
                                {/* Instagram Icon */}
                                <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                                    <rect x="3" y="3" width="18" height="18" rx="5" stroke="white" strokeWidth="2" />
                                    <circle cx="12" cy="12" r="4" stroke="white" strokeWidth="2" />
                                    <circle cx="17" cy="7" r="1" fill="white" />
                                </svg>
                            </a>
                        </div>


                    </div>

                    <div
                        style={{
                            width: "100%",
                            height: 1,
                            background: "rgba(255,255,255,0.25)",
                            margin: isMobile ? "32px 0 16px" : "44px 0 18px",
                        }}
                    />

                    <div
                        style={{
                            textAlign: "center",
                            fontSize: isMobile ? 13 : 14,
                            opacity: 0.9,
                            letterSpacing: 0.3,
                        }}
                    >
                        Copyright © 2025 by the nurse and the midwife. All Rights Reserved.
                    </div>
                </div>
            </div>

            {/* ================= FIXED BOTTOM PLAYER ================= */}


            {activeEp ? (
                <div
                    style={{
                        position: "fixed",
                        left: 0,
                        right: 0,
                        bottom: 0,
                        width: "100%",
                        zIndex: 9999,
                        background: "#1F6F78",
                        boxShadow: "0 -18px 55px rgba(0,0,0,0.25)",
                        paddingBottom: "env(safe-area-inset-bottom)",
                    }}
                >
                    <div
                        style={{
                            width: isMobile ? "95%" : screenWidth * 0.94,
                            marginLeft: "auto",
                            marginRight: "auto",
                            padding: isMobile ? "14px 0 14px" : "18px 0 18px",
                            fontFamily: "Poppins",
                            color: "#FFFFFF",
                            boxSizing: "border-box",
                        }}
                    >
                        {/* ✅ IMPORTANT: keep the audio element HERE so it always exists */}
                        <audio ref={audioRef} preload="metadata" />

                        {/* ================= TOP LINE (title + episode + subtitle centered) ================= */}
                        <div style={{ display: "grid", gridTemplateColumns: "1fr", rowGap: 6 }}>
                            <div
                                style={{
                                    fontSize: isMobile ? 14 : 22,
                                    fontWeight: 650,
                                    letterSpacing: 0.2,
                                    lineHeight: isMobile ? "14px" : "22px",
                                    whiteSpace: "nowrap",
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                    maxWidth: "100%",
                                }}
                            >
                                {activeEp.mainTitle || activeEp.title}
                            </div>

                            <div style={{ opacity: 0.9, fontSize: isMobile ? 11 : 13, fontWeight: 600 }}>
                                Episode {activeEp.episodeNumber}
                            </div>
                            {/*
                            <div
                                style={{
                                    fontSize: isMobile ? 12 : 14,
                                    fontWeight: 500,
                                    opacity: 0.95,
                                    letterSpacing: 0.2,
                                    textAlign: "center",
                                    marginTop: isMobile ? 0 : 0,
                                }}
                            >
                                {activeEp.subtitle || "INTRODUCTION TO THE PODCAST"}
                            </div>
*/}
                        </div>

                        {/* ================= SEEK BAR ================= */}
                        <div
                            style={{
                                marginTop: 10,
                                display: "grid",
                                gridTemplateColumns: isMobile ? "45px 1fr 45px" : "56px 1fr 56px",
                                gap: 10,
                                alignItems: "center",
                            }}
                        >
                            <div style={{ fontSize: isMobile ? 11 : 13, opacity: 0.95, fontWeight: 600 }}>{fmt(cur)}</div>

                            <input
                                type="range"
                                min={0}
                                max={1000}
                                value={dur ? Math.round((cur / dur) * 1000) : 0}
                                onChange={(e) => seekTo(e.target.value)}
                                style={{
                                    width: "100%",
                                    accentColor: "rgba(255,255,255,0.95)",
                                    cursor: "pointer",
                                }}
                            />

                            <div style={{ fontSize: isMobile ? 11 : 13, opacity: 0.95, fontWeight: 600, textAlign: "right" }}>
                                {fmt(dur)}
                            </div>
                        </div>

                        {/* ================= CONTROLS + VOLUME ================= */}
                        <div
                            style={{
                                marginTop: isMobile ? 5 : 14,
                                display: "grid",
                                gridTemplateColumns: isMobile ? "1fr" : "auto 1fr",
                                rowGap: isMobile ? 5 : 0,
                                alignItems: "center",
                                width: "100%",
                            }}
                        >
                            {/* controls */}
                            <div
                                style={{
                                    display: "grid",
                                    gridTemplateColumns: isMobile ? "42px 46px 42px" : "42px 72px 42px",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    columnGap: 15,
                                    justifySelf: isMobile ? "center" : "center", // ✅ keep centered
                                    //  backgroundColor:'red'
                                }}
                            >
                                <button
                                    onClick={goPrev}
                                    disabled={!canPrev}
                                    style={{
                                        border: "none",
                                        background: "transparent",
                                        color: "white",
                                        cursor: canPrev ? "pointer" : "not-allowed",
                                        opacity: canPrev ? 1 : 0.35,
                                        width: 42,
                                        height: 42,
                                        display: "grid",
                                        placeItems: "center",
                                        fontSize: 20,
                                    }}
                                    title="Previous"
                                >
                                    ⏮
                                </button>

                                <button
                                    onClick={togglePlay}
                                    style={{
                                        border: "none",
                                        cursor: "pointer",
                                        width: isMobile ? 46 : 72,
                                        height: isMobile ? 46 : 72,
                                        borderRadius: 999,
                                        background: "rgba(255,255,255,0.90)",
                                        color: "#0B1220",
                                        display: "grid",
                                        placeItems: "center",
                                        boxShadow: "0 14px 28px rgba(0,0,0,0.22)",
                                        fontWeight: 900,
                                        fontSize: isMobile ? 16 : 22,
                                    }}
                                    title={isPlaying ? "Pause" : "Play"}
                                >
                                    {isPlaying ? "❚❚" : "▶"}
                                </button>

                                <button
                                    onClick={goNext}
                                    disabled={!canNext}
                                    style={{
                                        border: "none",
                                        background: "transparent",
                                        color: "white",
                                        cursor: canNext ? "pointer" : "not-allowed",
                                        opacity: canNext ? 1 : 0.35,
                                        width: 42,
                                        height: 42,
                                        display: "grid",
                                        placeItems: "center",
                                        fontSize: 20,
                                    }}
                                    title="Next"
                                >
                                    ⏭
                                </button>
                            </div>

                            {/* volume */}
                            <div
                                style={{
                                    display: "flex",
                                    justifyContent: isMobile ? "center" : "flex-end",
                                    alignItems: "center",
                                    gap: 10,
                                    justifySelf: isMobile ? "center" : "end", // 
                                }}
                            >
                                <div style={{ fontSize: isMobile ? 14 : 18, opacity: 0.95 }}>🔊</div>
                                <input
                                    type="range"
                                    min={0}
                                    max={1}
                                    step={0.01}
                                    value={vol}
                                    onChange={(e) => setVol(Number(e.target.value))}
                                    style={{
                                        width: isMobile ? "60%" : 160,
                                        maxWidth: isMobile ? 240 : 160,
                                        accentColor: "rgba(255,255,255,0.95)",
                                        cursor: "pointer",
                                    }}
                                />
                            </div>
                        </div>

                        {/* ================= VIEW ALL ================= */}
                        <div
                            style={{
                                marginTop: isMobile ? 8 : 14,
                                display: "flex",
                                justifyContent: isMobile ? "center" : "flex-end",
                                alignItems: "center",
                            }}
                        >
                            <button

                                onClick={() => smoothScrollTo(window, 0, 1200)}


                                style={{
                                    border: "none",
                                    background: "transparent",
                                    cursor: "pointer",
                                    color: "#FFFFFF",
                                    fontWeight: 600,
                                    fontSize: isMobile ? 12 : 16,
                                    display: "inline-flex",
                                    alignItems: "center",
                                    gap: 6,
                                    padding: "6px 4px",

                                    letterSpacing: 0.2,
                                    fontFamily: "sans-serif"
                                }}

                                onMouseDown={pressDown}
                                onMouseUp={pressUp}
                                onMouseEnter={hoverIn}
                                onMouseLeave={hoverOut}
                                onTouchStart={pressDown}
                                onTouchEnd={pressUp}
                            >
                                View All Episodes
                                <FaArrowRightLong color="#FFFFFF" />
                            </button>
                        </div>
                    </div>
                </div>
            ) : null}


        </>
    );

}


//  <Button onClick={() => navigate('/Sign_up')} style={{ width: 190, height: 53, position:'absolute',top:30,right:30, borderWidth: 1, borderStyle: 'solid', borderColor: '#26B8AD',backgroundColor:'#F7941D',borderRadius:10 }} ><Typography textTransform={'Upercase'} style={{ fontFamily: "Open Sans", color: '#000000',fontSize:24,fontWeight:'700' }} >R</Typography><Typography textTransform={'lowercase'} style={{ fontFamily: "Open Sans", color: '#000000',fontSize:24,fontWeight:'700' }} >egister</Typography></Button>
